@if (loading) {
  <div class="text-center m-auto mt-5">
    <rbb-loader/>
    <small class="text-secondary d-block">Formular wird geladen...</small>
  </div>
} @else {
  <div class="container">
    <div class="alert alert-danger">
      Das Formular existiert nicht mehr oder wurde von der Fachabteilung vorübergehend offline genommen.
    </div>
  </div>
}
